export const AFASTAMENTOS_LIST = 'AFASTAMENTOS_LIST';
export const AFASTAMENTOS_LIST_START = 'AFASTAMENTOS_LIST_START';
export const AFASTAMENTOS_LIST_SUCCESS = 'AFASTAMENTOS_LIST_SUCCESS';
export const AFASTAMENTOS_LIST_ERROR = 'AFASTAMENTOS_LIST_ERROR';

export const TIPOSAFASTAMENTO_LIST = 'TIPOSAFASTAMENTO_LIST';
export const TIPOSAFASTAMENTO_LIST_START = 'TIPOSAFASTAMENTO_LIST_START';
export const TIPOSAFASTAMENTO_LIST_SUCCESS = 'TIPOSAFASTAMENTO_LIST_SUCCESS';
export const TIPOSAFASTAMENTO_LIST_ERROR = 'TIPOSAFASTAMENTO_LIST_ERROR';
